import { ILanguage } from "../types";

export const he: ILanguage = {
  translation: {
    root: {
      customize: "התאמה אישית",
      businessAccount: "חשבון עסקי",
      verificationStatus: "סטטוס אימות",
      note: "פֶּתֶק",
      companyInformation: "מידע על החברה",
      businessName: "שם עסקים*",
      enterBusinessName: "הזן שם עסקים",
      registrationNumber: "חברת Reg. ",
      registrationNumberPlaceholder: "הזן את מספר ההרשמה",
      taxVat: "מס 'רישום מס/מע\"מ מס'",
      vatPlaceholder: 'הזן מספר רישום מס/מע"מ',
      registeredAddress: "כתובת רשומה*",
      tradingAddress: "כתובת מסחר*",
      sameAsRegisteredAddress: "זהה לכתובת רשומה",
      billingInformation: "מידע על חיוב",
      billingPhoneNo: "טלפון חיוב מס '*",
      mode: "מצב",
      comments: "הערות",
      phonePlaceholder: "הזן את מספר הטלפון",
      billingEmail: 'דוא"ל חיוב*',
      emailPlaceholder: 'הזן דוא"ל חיוב',
      driverDetails: "פרטי הנהג",
      customerVerificationStatus: "סטטוס אימות לקוחות:",
      enterNationalInsuranceNumber: "הזן את מספר הביטוח הלאומי",
      enterYourProfession: "הזן את המקצוע שלך",
      enterDriving: "הזן נהיגה",
      profileImage: "תמונת פרופיל",
      number: "מִספָּר",
      image: "תְמוּנָה",
      uploadBack: "העלה בחזרה",
      uploadFront: "העלה חזית",
      issuedBy: "הונפק על ידי",
      document: "מִסְמָך",
      selectDocument: "בחר מסמך",
      addFile: "הוסף קובץ",
      noDataFound: "לא נמצאו נתונים",
      noDocumentsFound: "לא נמצאו מסמכים",
      documentUpdatedAt: "תעדכן ב",
      selectExpiryDate: "בחר תאריך תפוגה",
      selectExpiryDateUpload: "אנא בחר תאריך תפוגה לפני העלאה.",
      editExpiryDate: "ערוך תאריך תפוגה",
      status: "סטָטוּס",
      images: "תמונות",
      profession: "מִקצוֹעַ",
      middleName: "שם אמצעי",
      middleNameLabel: "שם אמצעי",
      enterMiddleName: "הזן שם אמצעי",
      nationality: "לאום",
      driving: "נְהִיגָה",
      listOfDocumentsUploaded: "רשימת המסמכים הועלה",
      listOfRequiredDocumentsUploaded: "רשימת המסמכים הנדרשים הועלה",
      documentType: "סוג מסמך",
      documentName: "שם מסמך",
      expiryDate: "תאריך תפוגה",
      confirmDelete: "אשר מחק",
      actions: "פעולות",
      completed: "הושלם",
      pending: "תָלוּי וְעוֹמֵד",
      documentDeleteConfirmMsg: "האם אתה בטוח שאתה רוצה למחוק את המסמך הזה?",
      address: "כְּתוֹבֶת",
      useRegisteredAddress: "השתמש בכתובת רשומה",
      billingEmailAddress: 'כתובת דוא"ל חיוב*',
      billingEmailLabel: 'כתובת דוא"ל לחיוב',
      accountNumber: "מספר חשבון",
      firstName: "שֵׁם פְּרַטִי*",
      firstNameLabel: "שֵׁם פְּרַטִי",
      lastName: "שֵׁם מִשׁפָּחָה*",
      lastNameLabel: "שֵׁם מִשׁפָּחָה",
      contactEmail: 'צור קשר עם כתובת הדוא"ל*',
      emailLabel: 'כתובת דוא"ל',
      contactPhone: "צור קשר עם טלפון מס '*",
      registeredAddressCaps: "כתובת רשומה",
      tradingAddressCaps: "כתובת מסחר",
      billingInformationCaps: "מידע על חיוב",
      customerContactCaps: "קשר לקוחות",
      contactEmailInvalid: 'אנא הכנס דוא"ל ליצירת קשר תקף.',
      typeAddress: "סוג הכתובת",
      taxFees: "מיסים ועמלות",
      vatTax: 'מע"מ/מס',
      registrationNum: "מספר ההרשמה",
      drivingLicenceNumber: "מספר רישיון נהיגה",
      invalidPhoneNumber: "מספר טלפון לא חוקי",
      onStartEmail: 'שלחנו לך דוא"ל כיצד להתחיל.',
      emailNotSeen:
        'אם אינך רואה את הדוא"ל תוך מספר דקות, בדוק את "דואר הזבל" או "תיקיית הספאם שלך ',
      registerNow: "הירשם עכשיו",
      email: 'דוא"ל',
      thankYou: "תודה",
      pickUpLocation: "מקום איסוף ",
      returnLocation: "מקום החזרה *",
      pickUpDate: "תאריך איסוף *",
      pickUpTime: "שעת איסוף *",
      invalidPickupLeadTime: "תאריך/שעת האיסוף שנבחרו מחוץ לחלון ההזמנה המותר",
      dropOffDate: "תאריך החזרה *",
      searchVehicles: "חפש רכבים",
      chooseLocation: "הזן מיקום או מיקוד",
      vehicleGallery: "גלריית רכבים",
      privacyPolicy: "מדיניות פרטיות",
      termsAndConditions: "תנאים והגבלות",
      dropOffTime: "זמן החזרה *",
      noVehiclesFound: "לא נמצאו רכבים התואמים לקריטריונים שנבחרו",
      noRecordFound: "מצטערים, לא נמצאו רשומות תואמות!",
      vehicles: "רכבים",
      endDate: "תאריך סיום",
      startDate: "תאריך התחלה",
      past: "עבר",
      search: "חיפוש",
      upcoming: "קרוב",
      current: "נוכחי",
      all: "הכל",
      more: "עוד",
      toBeAssigned: "טרם שויך",
      ref: "מספר ייחוס",
      reservation: "הזמנה",
      booking: "הזמנה",
      pricingSummary: "סיכום תמחור",
      bookingSummary: "סיכום הזמנה",
      subscriptionVehicle: "רכב במנוי",
      insurance: "ביטוח",
      addons: "תוספות",
      protectionPlan: "תוכנית הגנה",
      initialRental: "תשלום שכירות התחלתי",
      enrollmentFee: "דמי רישום",
      quantity: "כמות",
      subscriptionPrice: "מחיר מנוי",
      weekly: "שבועי",
      monthly: "חודשי",
      on: "בתאריך",
      numberOfDoors: "מספר דלתות",
      numberOfSeats: "מספר מושבים",
      transmission: "תיבת הילוכים",
      fuelType: "סוג דלק",
      week: "שבוע",
      day: "יום",
      hour: "שעה",
      month: "חודש",
      gropu1Icon: "סמל קבוצה 1",
      vatInclusive: "כולל מעמ",
      vat: "מעמ",
      rental: "השכרה",
      speedometer: "מד מהירות",
      available: "זמין",
      priceLowToHigh: "מחיר נמוך לגבוה",
      priceHighToLow: "מחיר גבוה לנמוך",
      weHaveSmartCars: "יש לנו רכבים חכמים",
      keylessSupport: "אנחנו תומכים בגישה ללא מפתח ברכבים החכמים שלנו",
      keylessVehicles: "הצג רכבים ללא מפתח",
      duration: "משך זמן",
      swapsAllowed: "ניתן להחליף",
      enrollmentAmount: "סכום רישום",
      subscriptionAmount: "סכום מנוי",
      mileageLimit: "מגבלת קילומטראז'",
      unlimited: "ללא הגבלה",
      weeks: "שבועות",
      months: "חודשים",
      pricePerExtraMile: "מחיר לכל קמ נוסף",
      insurancePolicy: "פוליסת ביטוח",
      removeSubscription: "הסר מנוי",
      noGroupFound: "לא נמצאו קבוצות עם הקריטריונים הללו!",
      vehicleTypeIcon: "סמל סוג רכב",
      min: "מינ'",
      selected: "נבחר",
      vehiclesSelected: "רכבים שנבחרו",
      selectVehicles: "בחר רכבים",
      personalDetails: "פרטים אישיים",
      selectAddons: "בחר תוספות",
      continue: "המשך",
      locationSurcharge: "תוספת מיקום",
      onTotalRentalAmount: "על סך השכירות הכוללת",
      oneWayFee: "עמלת נסיעה בכיוון אחד",
      oneWayRentalCharge: "דמי שכירות חד-כיוונית",
      total: "סהכ",
      firstMonthTotal: "סהכ חודש ראשון",
      firstWeekTotal: "סהכ שבוע ראשון",
      depositPayable: "פיקדון (לתשלום בעת האיסוף)",
      deposit: "פיקדון",
      insuranceCaps: "ביטוח",
      customAddon: "תוספת מותאמת אישית",
      chooseAPolicy: "בחר פוליסה",
      rate: "תעריף",
      typeOfValet: "סוג שירות חניה",
      nonNegotiable: "לא ניתן למשא ומתן",
      selectValet: "בחר שירות חניה",
      collectionAddress: "כתובת איסוף",
      remove: "הסר",
      deliveryAddress: "כתובת משלוח",
      additionalInformation: "מידע נוסף",
      confirmBooking: "אשר הזמנה",
      proceed: "המשך",
      getQuote: "קבל הצעת מחיר",
      for: "עבור",
      agreeWithTermsAndConditions: "אני מסכים לתנאים וההגבלות",
      selectCostCenter: "בחר מרכז עלות להזמנה",
      action: "פעולה",
      name: "שם",
      enterDrivingLicenceNumber: "הזן מספר רישיון נהיגה",
      enterLastName: "הזן שם משפחה",
      enterFirstName: "הזן שם פרטי",
      enterYourMail: "הזן את האימייל שלך",
      emailAsterisk: "אימייל*",
      quoteGeneratedCaps: "הצעת מחיר נוצרה",
      updated: "עודכן",
      rentalCharges: "חיובי השכרה",
      totalPayableAmount: "סכום כולל לתשלום",
      payMinimumAmount: "שלם סכום מינימלי",
      dueAmountPaidWhilePickup: "סכום לתשלום בעת האיסוף",
      payOnCollection: "שלם בעת האיסוף",
      CardAuthorization: "הכרטיס יאושר כעת אך הסכום ינוכה כאשר",
      starts: "מתחיל",
      confirm: "אשר",
      payAtTimeOfPickup: "כעת ושלם בעת האיסוף",
      payFullAmountNow: "שלם את הסכום המלא כעת",
      payFullAmountRightAway: "שלם את הסכום המלא מיד",
      FutureChargesRelatedToOngoingBooking:
        "חיובים עתידיים הקשורים להזמנה הנוכחית יחויבו בשיטת תשלום זו",
      saveThisCardForFutureInvoices:
        "שמור כרטיס זה לתשלום חשבוניות עתידיות עבור {{bookingSyntax}}",
      payLater: "שלם מאוחר יותר",
      creditLimitAssigned: "המסגרת האשראי שהוקצתה לעסק זה תשמש לתשלום זה",
      CreditsAgainstBooking: "קרדיטים ישמשו כנגד הזמנה זו",
      useCreditNoteBalance: "השתמש ביתרת שובר האשראי",
      telNo: "טלפון",
      vatNo: "מספר מעמ",
      customer: "לקוח",
      emailAddress: "כתובת אימייל",
      phoneNumber: "מספר טלפון",
      dateCreated: "תאריך יצירה",
      poNumber: "מספר הזמנת רכש",
      dateTime: "תאריך ושעה",
      dropOffLocation: "מיקום החזרה",
      contractHire: "השכרה בחוזה",
      subscription: "מנוי",
      charges: "חיובים",
      enrollmentFees: "דמי רישום",
      na: "לא זמין",
      grandTotal: "סהכ כולל",
      rentalPrice: "מחיר השכרה",
      daysProRated: "ימים מחושבים באופן יחסי",
      locationSurcharges: "תוספות מיקום",
      ofTotalRentalAmount: "מסך כל סכום ההשכרה",
      nextBilling: "חיוב הבא",
      subTotal: "סכום ביניים",
      discount: "הנחה",
      discountedPrice: "מחיר מוזל",
      description: "תיאור",
      descriptionLabel: "תיאור",
      thisIsA: "זהו",
      exemptedBooking: "הזמנה פטורה",
      thisIstestCourtsey: "זוהי הזמנת בדיקה/אדיבות",
      isCalculatedAgainst: "מחושב כנגד",
      priceAndSelectedAddons: "מחיר ותוספות נבחרות, לא כולל ביטוח ופיקדון",
      recurringWeeklyMonthlyInvoice:
        "חשבונית חוזרת שבועית/חודשית תיווצר אוטומטית לשבוע/חודש הבא.",
      additionalNote: "הערה נוספת",
      payableAtVehicleCollection: "לתשלום בעת איסוף הרכב",
      purchaseOrderUpdated: "מספר הזמנת הרכש עודכן בהצלחה",
      proceedToPay: "המשך לתשלום",
      searchResults: "תוצאות חיפוש",
      subscriptions: "מנויים",
      contractHireVehicleWeeklyMonthly: "רכב חוזה להשכרה שבועית/חודשית",
      subscribeVehicleWeeklyMonthly: "הרשם לרכב להשכרה שבועית/חודשית",
      contractNow: "חתום על חוזה עכשיו",
      subscribeNow: "הירשם עכשיו",
      backToBookingCategorySelection: "חזרה לבחירת קטגוריות הזמנה.",
      accountVerification: "אימות חשבון",
      profileNotVerifiedMessage:
        "הפרופיל שלך לא אומת. אנא צור קשר עם המפעיל שלך כדי להשלים את תהליך האימות ולהמשיך.",
      update: "עדכון",
      reference: "הפניה",
      companyRegistrationNumber: "מספר רישום חברה",
      availableFrom: "זמין מ",
      paellaDish: "מנת פאייה",
      vehicleCatalogues: "קטלוגי רכבים",
      vehicleDetails: "פרטי רכב",
      verification: "אימות",
      protectionPlans: "תוכניות הגנה",
      authorisedSignatory: "חותם מוסמך",
      item: "פריט",
      price: "מחיר",
      unitPrice: "מחיר ליחידה",
      vehicleSpecification: "מפרט הרכב",
      model: "דגם",
      color: "צבע",
      bodyType: "סוג גוף",
      tankCapacity: "קיבולת מיכל",
      interiorColor: "צבע פנימי",
      seats: "מושבים",
      doors: "דלתות",
      whatsIncluded: "מה כלול",
      timeVehicleSwap: "זמן החלפת רכב",
      contractualDetails: "פרטי חוזה",
      longerSubscribeSaveMore: "ככל שתירשם לזמן ארוך יותר, תחסוך יותר",
      tailorSubscriptionToNeeds: "התאם את המנוי לצרכים שלך",
      easyManagementOnline: "ניהול פשוט ונוח אונליין",
      SwapCarAndCancel: "החלף רכב או בטל בכל עת",
      customizeYourContract: "התאם אישית את החוזה שלך",
      selectPlan: "בחר תוכנית",
      selectTenure: "בחר תקופה",
      tentativeStartDate: "תאריך התחלה משוער",
      selectDate: "בחר תאריך",
      selectTime: "בחר שעה",
      contractSummary: "סיכום החוזה שלך",
      subscriptionChargesLabel: "חיובי מנוי",
      initialRentalPayment: "תשלום שכירות ראשוני",
      continueToPersonalDetails: "המשך לפרטים אישיים",
      noAvailableAddonsFound:
        "לא נמצאו תוספים זמינים התואמים לקריטריוני החיפוש שלך",
      nationalInsuranceNumber: "מספר ביטוח לאומי",
      updateQuote: "עדכן הצעת מחיר",
      driverNotAvailable: "הנהג אינו זמין, אנא פנה למפעיל ההשכרה",
      selectDeliverySlot: "בחר מועד משלוח",
      wantDelivered: "האם אתה רוצה משלוח?",
      verifyYourLicenceCaps: "אמת את רישיון הנהיגה שלך",
      validateAllFieldsForLicenceCheck:
        "אנא אמת או הזן את הפרטים הבאים כדי להמשיך לבדיקה. כל השדות חובה.",
      postCode: "מיקוד",
      thisAgreementAllows: "ההסכם הזה מאפשר ל",
      leftoverAgreement:
        "ולשותף הביטוחי שלנו לבצע בדיקות לרישיון הנהיגה שלך ולהעביר את הנתונים שלך למבטחים וגופים נוספים (Coastr) לצורך ניהול ההשכרה, פוליסת הביטוח וכו'. האם אתה מסכים?",
      verifyLicence: "אמת רישיון",
      licenceCheckingInProgress: "בדיקת רישיון בתהליך",
      checkingInProgress:
        "זה עלול להימשך עד 2 דקות, אנא המתן ואל תסגור את הדפדפן",
      licenceCheckingFailed: "בדיקת רישיון נכשלה",
      checkForCorrectDetails: "אנא בדוק שהזנת את הפרטים הנכונים.",
      tryAgainLater: "אם הבעיה נמשכת, נסה שוב מאוחר יותר.",
      licenceCheckedSuccessfully: "רישיון אומת בהצלחה",
      licenceSummaryAdded: "סיכום רישיון נוסף לפרופיל הלקוח",
      creditScore: "ציון אשראי",
      lastChecked: "נבדק לאחרונה",
      recheckCreditScore: "בדוק שוב את ציון האשראי",
      checkCreditScore: "בדוק ציון אשראי",
      proceedToPayment: "המשך לתשלום",
      paymentOverview: "סקירת תשלום",
      schedule: "לוח זמנים",
      contractDetails: "פרטי חוזה",
      plan: "תוכנית",
      swaps: "החלפות",
      payableDeposit: "פיקדון לתשלום",
      customerVerification: "אימות לקוח",
      provideAdditionalDetails:
        "אנא ספק את הפרטים הנוספים הבאים באזור החשבון לצורך יצירת ההזמנה",
      profilePhoto: "תמונת פרופיל",
      submitYourRequest:
        "לאחר השלמת הכל, הגש את הבקשה לאישור על ידי לחיצה על כפתור ההגשה למטה",
      submit: "שלח",
      uploadLicenceImages: "העלאת תמונות רישיון",
      add: "הוסף",
      uploadFrontBackLicence:
        "העלה תמונה קדמית ואחורית של הרישיון. פורמטים נתמכים: ‎.png, .jpeg, .jpg!",
      uploadLicenceImage: "העלה תמונת רישיון",
      authority: "רשות",
      drivingLicenceExpiryDate: "תאריך תפוגת רישיון נהיגה",
      licenceNumber: "מספר רישיון",
      preview: "תצוגה מקדימה",
      addOn: "תוסף",
      contact: "צור קשר",
      selectSlot: "בחר מועד",
      deliveryType: "סוג משלוח",
      experience: "חוויה",
      type: "סוג",
      bookATestDrive: "הזמן נסיעת מבחן",
      selectASlot: "בחר מועד",
      selectDateTimeSlot: "בחר תאריך ושעה",
      vehicleNotAvailable: "הרכב אינו זמין בתאריך שנבחר",
      selectDifferentDate: "אנא בחר תאריך אחר",
      selectCar: "בחר רכב",
      availableNow: "זמין כעת",
      new: "חדש",
      phone: "טלפון",
      customerDetails: "פרטי לקוח",
      dealershipAddress: "כתובת סוכנות",
      dealership: "סוכנות",
      bookingTime: "זמן הזמנה",
      bookingType: "סוג הזמנה",
      details: "פרטים",
      your: "שלך",
      confirmation: "אישור",
      selectDealership: "בחר סוכנות",
      testDriveRequested: "בקשת נסיעת מבחן",
      testDrive: "נסיעת מבחן",
      mobileNumber: "מספר נייד",
      drivingLicenseNumber: "מספר רישיון נהיגה",
      enterLicenseNumber: "הזן מספר רישיון",
      requestTestDrive: "בקשת נסיעת מבחן",
      slot: "מועד",
      vehicle: "רכב",
      selectSubsctiption: "בחר מנוי",
      pricesShownOnSelectedDuration: "המחירים מוצגים בהתאם למשך הזמן שנבחר",
      priceComparison: "השוואת מחירים",
      oneTime: "חד פעמי",
      subscriptionStartsAt: "המנוי מתחיל ב־",
      paymentProcessing: "מעבד תשלום",
      pleaseWait: "אנא המתן",
      paymentComplete: "התשלום הושלם",
      paymentInProgress: "התשלום בעיצומו",
      atleastUploadOne: "יש להעלות לפחות אחד",
      upload: "העלה",
      uploadServiceNotAvailable: "שירות ההעלאה אינו זמין. אנא נסה שוב.",
      uploading: "מעלה...",
      atDealership: "בסוכנות",
      atHome: "בבית",

      enterYourEmailPassword: "הזן את האימייל והסיסמה שלך כדי להיכנס",
      enterMailHere: "הזן את האימייל שלך כאן",
      required: "חובה",
      password: "סיסמה",
      reset: "איפוס",
      otpForPasswordReset: "תקבל קוד OTP לאיפוס הסיסמה באימייל שלך",
      sendOtp: "שלח OTP",
      loginInstead: "התחבר במקום זאת",
      verifyOtp: "אמת OTP",
      otp: "OTP",
      otpSentToEmail: "OTP נשלח לאימייל שלך",
      enterOtp: "הזן OTP",
      enterOtpHere: "הזן כאן את ה‑OTP",
      verify: "אמת",
      setNewPassword: "הגדר סיסמה חדשה",
      eightCharLong: "חייב להיות באורך של 8 תווים",
      reenterPassword: "הזן שוב את הסיסמה כאן",
      signInAs: "התחבר בתור",
      as: "כـ",
      selectAccountToProceed: "בחר חשבון להמשך",
      personalAccount: "חשבון אישי",
      asBusinessCustomer: "כבעל עסק",
      asDriver: "כנהג",
      enterPassword: "הזן את הסיסמה כאן",
      registerAs: "הירשם בתור",
      individual: "פרט",
      business: "עסק",
      operatorMandatedCustomerCheck:
        "הספק קבע בדיקת לקוחות לפני אישור הזמנה. אנא המתן לאישור.",
      createAccount: "צור חשבון",
      emailedHowToGetStarted: "שלחנו אימייל עם הוראות להתחלה.",
      ifDontSeeEmail: "אם לא קיבלת, בדוק תקיית 'ספאם' או 'דואר זבל'.",
      previousVehicleDetails: "פרטי רכב קודמים",
      registration: "רישום",
      makeModel: "יצרן/דגם",
      vin: "מספר VIN",
      driverAssigned: "נהג הוקצה",
      currentVehicleDetails: "פרטי רכב נוכחיים",
      priceGroup: "קבוצת תמחור",
      unlimitedMileage: "קילומטראז’ ללא הגבלה",
      paymentStatus: "מצב תשלום",
      invoiceNumber: "מספר חשבונית",
      deliveryDetails: "פרטי משלוח",
      collectionDetails: "פרטי איסוף",
      coiDetails: "פרטי COI",
      policyName: "שם הפוליסה",
      planName: "שם התוכנית",
      policyNumber: "מספר פוליסה",
      provider: "ספק",
      vehicleSwapDetails: "פרטי החלפת רכב",
      swapMyCar: "החלף רכב שלי",
      NoOfSwapsAllowed: "מספר החלפות מותרים",
      NoOfSwapsAvailed: "החלפות בשימוש",
      NoOfSwapsRemaining: "החלפות שנותרו",
      swapRequestHistory: "היסטוריית בקשות החלפה",
      requestedOn: "נדרש בתאריך",
      swapDate: "תאריך החלפה",
      oldVehicle: "רכב קודם",
      newVehicle: "רכב חדש",
      addonsDetails: "פרטי תוספות",
      paymentDetails: "פרטי תשלום",
      billingPeriod: "תקופת חיוב",
      creationDate: "תאריך יצירה",
      invoiceType: "סוג חשבונית",
      regular: "רגיל",
      depositDetails: "פרטי פיקדון",
      amount: "סכום",
      totalPaidAmount: "סכום כולל ששולם",
      cancellationCharges: "דמי ביטול",
      totalRefundAmount: "סכום כולל להחזר",
      anUnpaid: "לא שולם",
      aPartiallyPaid: "שולם חלקית",
      thisIs: "זהו",
      pleaseContactUs: "אנא פנה אלינו לשאלות נוספות",
      reasonToCancelTheBooking: "בחר סיבה לביטול ההזמנה",
      enterTheReason: "הזן את הסיבה",
      dismiss: "דלג",
      selectVehicle: "בחר רכב",
      bookingConfirmationInProgress: "אישור ההזמנה בעבודה",
      pleaseProvideTheReason: "אנא ספק את הסיבה",
      quote: "הצעה",
      management: "ניהול",
      pickupDateTimePassed: "תאריך/שעת איסוף עבר או חינם",
      profileRejectedOrPending: "הפרופיל שלך נדחה או ממתין לאישור",
      testDriveAgreement: "הסכם נסיעת מבחן",
      rentalAgreement: "הסכם שכירות",
      contractHireAgreement: "הסכם שכירות חוזה",
      subscriptionAgreement: "הסכם מנוי",
      zeroChargeBooking: "הזמנה ללא עלות תאושר רק על ידי מפעיל",
      pickupDateTimeInPast: "תאריך/שעת איסוף בעבר",
      creditNoteSummary: "סיכום שובר זיכוי",
      customerName: "שם לקוח",
      customerEmail: "אימייל לקוח",
      creditNoteRef: "אסמכתא לשובר זיכוי",
      invoiceRef: "אסמכתא לחשבונית",
      totalAmount: "סכום כולל",
      amountAdjustedRefunded: "סכום מותאם/מוחזר",
      amountAvailable: "סכום זמין",
      adjustments: "התאמות",
      particulars: "פרטים",
      adjustedToInvoice: "מותאם לחשבונית",
      adjustedAt: "מותאם בתאריך",
      creditNotes: "שוברי זיכוי",
      availableBalance: "יתרה זמינה",
      searchCreditNoteId: "חפש אסמכתא לשובר",
      active: "פעיל",
      exhausted: "נגמר",
      creditNoteId: "מספר שובר",
      dateGenerated: "נוצר בתאריך",
      amountRefunded: "סכום שהוחזר",
      amountRemaining: "סכום שנותר",
      dashboard: "לוח בקרה",
      activeVehiclesCount: "מס' רכבים פעילים",
      totalActiveBookings: "סה' הזמנות פעילות",
      totalVehicles: "סה' רכבים",
      vehicleChecks: "בדיקות רכב",
      inProgressBookings: "הזמנות בתהליך",
      vehicleChecksCompleted: "בדיקות רכב הושלמו",
      vehicleChecksPending: "בדיקות רכב ממתינות",
      dailyBalance: "יתרה יומית",
      totalOutstanding: "סה' חוב",
      UnpaidInvoices: "חשבוניות לא שולמו",
      regularInvoices: "חשבוניות רגילות",
      sundryInvoices: "חשבוניות שונות",
      addNewDriver: "הוסף נהג חדש",
      phoneNo: "טלפון",
      drivingLicenceImage: "תמונה רישיון נהיגה",
      licenceIssuedBy: "הרישיון הונפק על ידי",
      licenceExpiryDate: "תאריך תפוגת רישיון",
      drivingLicenceIssueDate: "תאריך הנפקת רישיון נהיגה",
      dateOfBirth: "תַאֲרִיך לֵידָה",
      taskDetailsNotFound: "פרטי המשימה לא נמצאו.",
      bookingRef: "אסמכתא להזמנה",
      rateYourExperience: "דרג את חווייתך",
      driverInformation: "פרטי נהג",
      saveDrivers: "שמור נהגים",
      expiry: "תפוגה",
      areYouSureDriver: "האם אתה בטוח שברצונך להסיר נהג זה?",
      drivers: "נהגים",
      noDriverFound: "מצטערים, לא נמצאו נהגים!",
      pcoIssueDate: "תאריך הנפקה של רישיון PCO לנהג",
      invoices: "חשבוניות",
      searchInvoiceId: "חפש אסמכתא לחשבונית",
      unpaid: "לא שולם",
      paid: "שולם",
      void: "בוטל",
      invoiceId: "מספר חשבונית",
      invoiceDate: "תאריך חשבונית",
      balanceDue: "יתרת חוב",
      dueDate: "תאריך יעד",
      invoiceSummary: "סיכום חשבונית",
      invoice: "חשבונית",
      sundry: "שונות",
      addPayment: "הוסף תשלום",
      customerPhoneNumber: "טלפון הלקוח",
      invoiceReference: "אסמכתא חשבונית",
      period: "תקופה",
      invoiceVoidedBy: "החשבונית בוטלה על ידי",
      invoicePeriod: "תקופת חשבונית",
      invoiceStatus: "סטטוס חשבונית",
      invoiceAmount: "סכום חשבונית",
      amountDue: "סכום לתשלום",
      generatedAt: "נוצר בתאריך",
      vehicleRentalCharges: "חיובי השכרת רכב",
      refundable: "ניתן להחזרה",
      date: "תאריך",
      thisIsTestCourtsey: "זהו ניסוי/מחווה",
      invoicesConsolidated: "חשבוניות מולטיפליות",
      payments: "תשלומים",
      exempted: "פטור",
      pleaseLoginFirst: "אנא התחבר תחילה",
      account: "חשבון",
      tracking: "מעקב",
      uploadImages: "העלה תמונות",
      updateVehicleState: "עדכן מצב רכב",
      vehicleImage: "תמונת רכב",
      fuelStatus: "מצב דלק",
      batteryStatus: "מצב סוללה",
      odometerReading: "מד מרחק",
      nextServiceDetails: "פרטי שירות הבא",
      serviceType: "סוג שירות",
      serviceStatus: "סטטוס שירות",
      appointmentDate: "תאריך פגישה",
      estdCompletionDate: "תאריך סיום משוער",
      serviceProviderName: "שם ספק השירות",
      serviceProviderAddress: "כתובת ספק השירות",
      notesForDriver: "הערות לנהג",
      exteriorDamages: "נזקים חיצוניים",
      interiorDamages: "נזקים פנימיים",
      generalChecks: "בדיקות כלליות",
      accessoriesChecks: "בדיקות אבזור",
      chooseFuelLevel: "בחר רמת דלק",
      lastReported: "דווח לאחרונה",
      circumstance: "נסיבות",
      title: "כותרת",
      damageKind: "סוג נזק",
      damageArea: "אזור נזק",
      referenceNumber: "מספר אסמכתא",
      damageDetail: "פירוט נזק",
      addImage: "הוסף תמונה",
      addImages: "הוסף תמונות",
      done: "בוצע",
      searchExistingDriver: "חפש נהג קיים",
      success: "הצלחה",
      assignDriver: "הקצה נהג",
      plate: "לוחית רישוי",
      unassigned: "לא הוקצה",
      assigned: "הוקצה",
      make: "יצרן",
      vehicleAppearOnceAssigned: "רכבים יופיעו לאחר שיוקצו לך!",
      searchVehicle: "חפש רכב",
      trackingHistoryHrs: "היסטוריית זמן מעקב (שעות)",
      telemetryDevice: "מכשיר טלימטריה",
      lastLocation: "מיקום אחרון",
      latitude: "קו רוחב",
      longitude: "קו אורך",
      forSelectedPeriod: "לתקופה הנבחרת –",
      milesDriven: "מיילים שנעשו",
      engineHours: "שעות מנוע",
      fuelUsageLitres: "צריכת דלק (ליטרים)",
      stoppagehours: "שעות עצירה",
      chargeStatus: "מצב טעינה",
      fuelUsage: "צריכת דלק",
      batteryLevel: "רמת סוללה",
      speedLimit: "הגבלת מהירות",
      invalidEmailAddress: "כתובת אימייל לא חוקית",
      unableLoadCompanyDetails: "לא ניתן לטעון פרטי חברה",
      bookingConfirmationProgress: "אישור ההזמנה מתבצע...",
      doNotHitBack:
        "אנא אל תלחץ על חזור, בטל או סגור את הדפדפן. תהליך זה עשוי לקחת עד 2 דקות.",
      summary: "סיכום",

      addNew: "הוסף חדש",
      street: "רחוב",
      city: "עיר",
      regionState: "אזור/מדינה",
      country: "מדינה",
      zipPostalCode: "מיקוד",
      cardAuthorizeNowButAmountLater:
        "הכרטיס יאושר כעת אך החיוב יתבצע בתחילת ההזמנה",
      saveThisCardForFutureInvoicesBooking:
        "שמור כרטיס זה לתשלום חשבוניות עתידיות עבור הזמנה זו.",
      confirmBookingPayLater: "אשר הזמנה, שלם מאוחר יותר",
      confirmBookingAndPayAtPickup: "אשר הזמנה כעת ושלם בעת האיסוף",
      bookingReferenceNumber: "מספר אישור הזמנה",
      pickupDetails: "פרטי איסוף",
      dropoffDetails: "פרטי החזרה",
      to: "עד",
      bookingReference: "אישור הזמנה",
      invoiceStartDate: "תאריך התחלת חשבונית:",
      invoiceEndDate: "תאריך סיום חשבונית:",
      availableAtLocations: "זמין במיקומים",
      benefits: "הטבות",
      passportNumber: "מספר דרכון",
      enterPassportNumber: "הזן את מספר הדרכון שלך",
      vehicleSwapRequest: "בקשת החלפת רכב",
      checkVehicleAvailability: "בדוק זמינות רכב",
      pleaseSelectDateAndSearch: "בחר תאריך ולחץ על חיפוש לזמינות רכב",
      noVehicleFoundForSelectedDate: "לא נמצאה רכב לתאריך הנבחר",
      notes: "הערות",
      writeYourNoteHere: "כתוב את ההערה שלך כאן",
      updateRequest: "עדכן בקשה",
      generateRequest: "צור בקשה",
      cancelRequest: "בטל בקשה",
      operator: "מפעיל",
      you: "אתה",
      maximum: "מקסימום",
      imagesAreAllowed: "ניתן להעלות תמונות.",
      dragAndDropFile: "גרור ושחרר קובץ או לחץ",
      areAllowed: "מותר",
      cancelBooking: "בטל הזמנה",
      booked: "הוזמן",
      organisation: "ארגון",
      vatNumber: "מספר עוסק מורשה",
      sort: "מיין",
      DELETE_DRIVER_DESCRIPTION: "האם אתה בטוח שברצונך למחוק את הנהג?",
      driverActions: {
        "Are you sure you want to delete the driver?":
          "האם אתה בטוח שברצונך למחוק את הנהג?",
        "Delete Driver": "מחק נהג",
      },
      currentInvoiceStatus: {
        PAID: "שולם",
        UNPAID: "לא שולם",
        VOID: "מבוטל",
        "PARTIALLY PAID": "שולם חלקית",
        DRAFT: "טיוטה",
      },
      currentBookingStatus: {
        CANCELLED: "בוטל",
        COMPLETED: "הושלם",
        "CONFIRMATION IN PROCESS": "אישור בתהליך",
        CONFIRMED: "מאושר",
        "IN PROGRESS": "בתהליך",
        QUOTE: "הצעת מחיר",
        DRAFT: "טיוטה",
        "REQUIRES APPROVAL": "דורש אישור",
        DECLINED: "נדחה"
      },
      minBookingDurationMessage:
        "משך ההזמנה המינימלי הוא {{hours}} שעות. אנא עדכן את תאריך ושעת האיסוף או ההחזרה בהתאם.",
      maxBookingDurationMessage:
        "משך ההזמנה המקסימלי הוא {{days}} ימים. אנא עדכן את תאריך ושעת האיסוף או ההחזרה בהתאם.",
      usevaletTypes: {
        Delivery: "משלוח",
        Collection: "איסוף",
        "Delivery and Collection": "משלוח ואיסוף",
      },
      selectCollectionSlot: "בחר חלון זמן לאיסוף",
      driverUnavailableNote:
        "הערה: הנהג אינו זמין, אנא צור קשר עם מפעיל ההשכרה.",
      cancellationReasons: {
        "Requirement changed": "הדרישה השתנתה",
        Price: "מחיר",
        Other: "אחר",
      },
      imagePreview: "תצוגה מקדימה של תמונה",
      markDamage: "סמן נזק",
      vehicleDamageImages: "תמונות נזק לרכב",
      incidentDate: "תאריך האירוע",
      incidentTime: "שעת האירוע",
      clear: "נקה",
      bookingStatus: "סטטוס הזמנה",
      daysInBooking: "ימים בהזמנה",
      accumulatedDays: "ימים שנצברו",
      endingThisMonth: "סיום החודש",
      creditUtilisation: "ניצול אשראי",
      creditLimit: "מגבלת אשראי",
      utilized: "מנוצל",
      totalDrivers: "סה\"כ נהגים",
      vehiclesAllocated: "כלי רכב הוקצו",
      mileageOverview: "סקירה כללית של קילומטראז '",
      mileageLimitExited: "מגבלת קילומטראז 'יצאה",
      approachingMileageLimits: "מגבלות קילומטראז 'מתקרבות",
      motReminders: "תזכורות MOT",
      totalMotTests: "סה\"כ מבחני MOT",
      healthCheckReminders: "תזכורות לבדיקות בריאות",
      totalHealthCheckTests: "סה״כ בדיקות בדיקות בריאות",
      failed: "נִכשָׁל",
      serviceReminders: "תזכורות שירות",
      overdue: "איחור",
      totalServiceReminders: "סך תזכורות השירות",
      createNewServiceRequest: "צור בקשת שירות חדשה",
      serviceDetails: "פרטי השירות",
      selectedVehicle: "רכב נבחר",
      serviceRequestSelectVehicle: "בחר רכב",
      loadingVehicles: "טוען רכבים...",
      noActiveVehiclesFound: "לא נמצאו רכבים פעילים",
      addDetails: "הוסף פרטים",
      addItems: "הוסף פריטים",
      issueType: "סוג הבעיה",
      issueTypePlaceholder: "לדוגמה, מנעול שבור",
      descriptionPlaceholder: "לדוגמה, מנעול דלת קדמית שמאלית",
      uploaded: "הועלה",
      additionalComments: "הערות נוספות",
      additionalCommentsPlaceholder: "הוסף כל מידע נוסף...",
      submitting: "שולח...",
      submitRequest: "שלח בקשה",
      serviceRequestNote: "הבקשה שלך תיבדק על ידי צוות השירות שלנו. תקבל התראה ברגע שתאושר או אם יידרש מידע נוסף.",
      serviceRequestDetails: "פרטי בקשת השירות",
      createdDate: "תאריך יצירה",
      estimatedCost: "עלות מוערכת",
      requestProgress: "התקדמות הבקשה",
      issuesReported: "בעיות שדווחו",
      issue: "בעיה",
      imageAlt: "תמונה",
      serviceProvider: "ספק שירות",
      appointment: "פגישה",
      at: "ב",
      estimatedCompletion: "סיום משוער",
      workToBeDone: "עבודה לביצוע",
      cost: "עלות",
      totalCost: "עלות כוללת",
      requestDeclined: "בקשה נדחתה",
      communication: "תקשורת",
      serviceTeam: "צוות שירות",
      noCommunicationYet: "אין תקשורת עדיין",
      addMessage: "הוסף הודעה",
      askQuestionPlaceholder: "שאל שאלה או ספק מידע נוסף...",
      sending: "שולח...",
      sendMessage: "שלח הודעה",
      additionalInformationRequested: "התבקש מידע נוסף",
      provideFollowingInformation: "אנא ספק את המידע הבא כדי לעזור לנו לעבד את בקשתך:",
      yourAnswer: "התשובה שלך:",
      typeAnswerHere: "הקלד את תשובתך כאן...",
      submitAnswers: "שלח תשובות",
      approved: "אושר",
      serviceRequests: "בקשות שירות",
      scheduledServicesTitle: "שירותים מתוזמנים",
      scheduledServicesBellAria: "הצג שירותי רכב מתוזמנים",
      noScheduledServices: "אין שירותים מתוזמנים",
      approveScheduledServiceSuccess: "השירות אושר בהצלחה",
      requestChangesSuccess: "בקשת השינוי נשלחה לאישור",
      requestChanges: "בקש שינויים",
      modifyServiceRequest: "ערוך בקשת שירות",
      modifyDetails: "ערוך פרטים",
      vehicleAndCategory: "רכב וקטגוריה",
      cannotModify: "לא ניתן לערוך",
      appointmentDetails: "פרטי התור",
      time: "שעה",
      scheduledServiceReviewHint: "אנא בדקו את השירות המתוזמן. אשרו אם הפרטים נכונים, או בקשו שינויים.",
      approveService: "אשר שירות",
      jobSheet: "גיליון עבודה",
      declined: "נדחה",
      lastUpdated: "עודכן לאחרונה",
      explainChangesPlaceholder: "הסבר מדוע אתה זקוק לשינויים אלה...",
      submitChanges: "שלח שינויים",
      expenses: "הוצאות",
      filters: "מסננים",
      applyFilters: "החל מסננים",
      activeFilters: "מסננים פעילים",
      newServiceRequest: "בקשת שירות חדשה",
      rowsPerPage: "שורות לעמוד:",
      of: "מתוך",
      moreThan: "יותר מ",
      searchServiceRequestsPlaceholder: "חפש לפי מספר הפניה, רכב או סטטוס...",
      selectOption: "בחר אפשרות",
      selectMultiple: "בחר אפשרות אחת או יותר",
      uploadPhoto: "העלה תמונה",
      view: "הצג",
      typeYourResponse: "הקלד את תשובתך",
      pleaseSelectServiceType: "אנא בחר סוג שירות",
      pleaseSelectServiceCategory: "אנא בחר קטגוריית שירות",
      selectServiceType: "בחר סוג שירות",
      serviceCategory: "קטגוריית שירות",
      selectServiceCategory: "בחר קטגוריית שירות",
      unableToDetermineServiceBranch: "לא ניתן לקבוע את סניף השירות שלך. אנא נסה שוב מאוחר יותר.",
      accidentDamageInformation: "מידע על תאונה / נזק",
      documentUploads: "העלאת מסמכים",
      adHoc: "Ad-Hoc",
      emergency: "חירום",
      serviceQuestionnaire: "שאלון שירות",
      serviceQuestionnaireDescription: "אנא ספק כמה פרטים נוספים כדי שצוות השירות שלנו יוכל להכין הכל מראש.",
      selectServiceCategoryPrompt: "בחר קטגוריית שירות כדי לראות את השאלות הנדרשות עבור שירות זה.",
      noServiceQuestionsForType: "אין שאלות נוספות לסוג שירות זה. תוכל להמשיך עם הבקשה.",
      fileUploadGuidance: "JPEG/PNG עד 5 MB לקובץ.",
      optionalServiceQuestion: "שאלה אופציונלית — ענה אם זה עוזר לצוות שלנו.",
      requestCreated: "בקשה נוצרה",
      underReview: "בבדיקה",
      inProgress: "בתהליך",
      photo: "תמונה",
      hiThere: "שלום,",
      serviceRequestDeclinedMessage: "בדקנו את בקשת השירות שלך, אבל היא לא יכולה להיות מאושרת כרגע.",
      whatWeNeed: "מה שאנחנו צריכים:",
      declineReasonGeneric: "זה יכול להיות בגלל פרטים חסרים, זכאות לשירות או תנאי אישור אחרים.",
      declineInstruction: "אנא בדוק את המידע שלך והגש בקשה חדשה ברגע שהעדכונים האלה במקום.",
      answered: "נענה",
      pendingAnswer: "ממתין לתשובה",
      requiredField: "תגובה זו נדרשת",
      questionsAnswered: "שאלות נענו",
      readyToSubmitChanges: "מוכן לשלוח עדכונים",
      questionsUpToDate: "כל התשובות מעודכנות",
      updateAnyAnswerToResubmit: "עדכן כל תשובה למעלה אם אתה צריך לשלוח מידע חדש.",
      answerTypeText: "טקסט",
      answerTypeYesNo: "כן / לא",
      answerTypeDropdown: "תפריט נפתח",
      answerTypeMultiSelect: "בחירה מרובה",
      answerTypeFileUpload: "העלאת תמונה",
      pendingApproval: "ממתין לאישור",
      awaitingMoreInformation: "ממתין למידע נוסף",
      closed: "סגור",
      noServiceRequestsFound: "לא נמצאו בקשות שירות",
      fleetAllocation: "הקצאת צי",
      fleetAllocations: "הקצאות צי",
      userAgreement: "הסכם משתמש",
      organisationCode: "קוד ארגון",
      serviceReference: "התייחסות שירות",
      completionDate: "תאריך השלמה",
      addTask: "הוסף משימה",
      noTaskFound: "לא נמצאו משימות. תוכל להוסיף משימות ידנית.",
      taskName: "שם משימה",
      features: "תכונות",
      interiorFeatures: "תכונות פנימיות",
      exteriorFeatures: "תכונות חיצוניות",
      safetyAndTechnicalFeatures: "תכונות בטיחות וטכניות",
      otherFeatures: "תכונות נוספות",
      privateHiresNo: "שכירים פרטיים לא",
      pcoPrivateHiresHireDLNo: "PCO/שכירות פרטית DL NO",
      gender: "מגדר",
      secondaryEmailAddress: "כתובת אימייל משנית",
      secondaryPhoneNumber: "מספר טלפון משני",
      driverAge: "גיל הנהג",
      licenceDuration: "משך הרישיון",
      penaltyPoints: "נקודות עונשין",
      insuranceClaimsHistory: "היסטוריית תביעות ביטוח",
      pcoExpiryDate: "תאריך תפוגה של PCO",
      state: "מדינה",
      selectBookingType: "בחר סוג הזמנה",
      selectBookingTypeDialog: "אנא בחר אחד מסוגי ההזמנה הבאים כדי להמשיך בהזמנה",
      regularBooking: "הזמנה רגילה",
      contactlessBooking: "הזמנה ללא מגע",
      reviewBookingDetails: "סקור את פרטי ההזמנה",
    },
    validation: {
      otpLengthMismatch: "אורך ה-OTP חייב להיות 6 תווים",
      invalidOtp: "OTP לא חוקי",
      required: "{{field}} נדרש",
      billingEmailInvalid: 'אנא הכנס דוא"ל חיוב תקף.',
      billingEmailRequired: 'נדרש דוא"ל חיוב.',
      addressRequired: "כתובת נדרשת",
      phoneNumberRequired: "מספר טלפון נדרש.",
      businessNameRequired: "שם העסק נדרש.",
      registrationNumberRequired: "נדרש מספר רישום",
      vatRequired: "נדרש מספר עוסק מורשה/מס",
      accountNumberRequired: "נדרש מספר חשבון",
      registeredAddressRequired: "נדרשת כתובת רשומה",
      registeredAddressCountryRequired: "יש צורך במדינה",
      registeredAddressStateRequired: "המדינה נדרשת",
      registeredAddressCityRequired: "עיר נדרשת",
      registeredAddressStreetRequired: "נדרש רחוב",
      tradingAddressRequired: "נדרשת כתובת מסחר",
      tradingAddressCountryRequired: "יש צורך במדינה",
      tradingAddressStateRequired: "המדינה נדרשת",
      tradingAddressCityRequired: "עיר נדרשת",
      tradingAddressStreetRequired: "נדרש רחוב",
      contactEmailRequired: 'נדרש דוא"ל ליצירת קשר.',
      firstNameRequired: "נדרש שם פרטי.",
      middleNameRequired: "שם אמצעי הוא שדה חובה.",
      lastNameRequired: "שם משפחה נדרש.",
      locationRequired: "נדרש מיקום",
      streetZipcodeRequired: "נדרש רחוב/zipcode",
      emailIsRequired: "נדרש אימייל",
      termsConditionsAccepted: "יש להסכים לתנאים וההגבלות",
      drivingLicenceNumberRequired: "נדרש מספר רישיון נהיגה",
      nationalInsuranceNumberRequired: "נדרש מספר ביטוח לאומי",
      enterValidPhoneNumber: "הזן מספר טלפון תקני.",
      enterValidEmailAddress: "אנא הזן כתובת אימייל תקינה",
      authorityRequired: "נדרש לציין רשות",
      licenceNumberRequired: "נדרש להזין מספר רישיון",
      licenceExpiryDateRequired: "נדרש להזין תאריך תפוגת רישיון",
      expiryDateRequired: "נדרש תאריך תפוגה",
      numberIsRequired: "נדרש מספר",

      passwordLengthValidaion: "אורך הסיסמה חייב להיות לפחות 8 תווים",
      passwordContainUppercase: "הסיסמה חייבת להכיל לפחות אות גדולה אחת",
      passwordContainLowercase: "הסיסמה חייבת להכיל לפחות אות קטנה אחת",
      passwordContainOneNumber: "הסיסמה חייבת להכיל לפחות מספר אחד",
      passwordContainSpecialCharacter: "הסיסמה חייבת להכיל לפחות תו מיוחד אחד",
      passwordMustMatch: "הסיסמאות חייבות להיות זהות",
      atleastOneUppercase: "לפחות אות גדולה אחת",
      atleastOneLowercase: "לפחות אות קטנה אחת",
      atleastOneNumericalChar: "לפחות תו מספרי אחד",
      atleastOneSpecialChar: "לפחות תו מיוחד אחד",
      pleaseEnterAValidEmail: 'אנא הזן כתובת דוא"ל תקינה',
      driverNotFound: "הנהג לא נמצא",
      batteryStatusNumber: "מצב הסוללה חייב להיות מספר",
      batteryStatusCantNegative: "מצב הסוללה לא יכול להיות שלילי",
      batteryStatusCantMoreHundred: "מצב הסוללה לא יכול לעלות על 100%",
      batteryStatusRequired: "נדרש מצב סוללה",
      odometerReadingMustNumber: "קריאת מד המרחק חייבת להיות מספר",
      odometerReadingRequired: "נדרשת קריאת מד מרחק",
      odometerMustEqualOrHigherLast:
        "קריאת מד המרחק חייבת להיות שווה או גבוהה מהקריאה האחרונה",
      titleIsRequired: "נדרש כותרת.",
      damageKindIsRequired: "נדרש סוג נזק.",
      descriptionIsRequired: "נדרש תיאור.",
      damageImageIsRequired: "נדרש תמונת נזק.",
      professionIsRequired: "נדרש מקצוע",
      passportNineCharacters: "מספר הדרכון חייב להיות של 9 תווים",
      passportIsRequired: "דרכון נדרש",
      organisationCodeRequired: "נדרש קוד ארגון",
      userNotFound: "משתמש לא נמצא",
      invalidPassword: "סיסמה לא חוקית",
      passwordLengthError: "אורך הסיסמה חייב להיות לפחות 8 תווים",
      customerPCONumberRequired: "נדרש מספר רישיון PCO / השכרה פרטית",
      genderRequired: "נדרש מין",
      nationalityRequired: "נדרש לאום",
    },
    misc: {
      edit: "ערוך",
      logOut: "התנתק",
      licence: "רישיון",
      cancel: "ביטול",
      save: "שמור",
      status: {
        PENDING: "ממתין",
        APPROVED: "מאושר",
        DECLINED: "נדחה",
        IN_REVIEW: "בתהליך בדיקה",
      },
      delete: "מחק",
      create: "צור",
      signIn: "התחבר",
      select: "בחר",
      back: "חזור",
      error: "שגיאה",
      yes: "כן",
      no: "לא",
      payConfirm: "שלם ואשר",
      clickToAdd: "לחץ להוספה",
      close: "סגור",
      download: "הורד",
      selectCaps: "בחר",
      forgotPassword: "שכחת סיסמה",
      pleaseNote: "שים לב",
      front: "קדמי",
      columnKey: {
        "#": "#",
        Particulars: "פרטים",
        Quantity: "כמות",
        "Unit Price": "מחיר יחידה",
        Duration: "משך",
        "Discounted Price": "מחיר מוזל",
        "VAT/TAX": 'מע"מ/מס',
        Amount: "סכום",
      },
      columnLabelToKeyMap: {
        ITEM: "פריט",
        DESCRIPTION: "תיאור",
        QUANTITY: "כמות",
        "UNIT PRICE": "מחיר יחידה",
        DURATION: "משך",
        "DISCOUNTED PRICE": "מחיר מוזל",
        "VAT/TAX": 'מע"מ/מס',
        PRICE: "מחיר",
      },
      paymentColumnsKey: {
        Date: "תאריך",
        Amount: "סכום",
        "Mode Of Payments": "אמצעי תשלום",
        Status: "סטטוס",
      },
      consolidatedInvoicesColumnsKey: {
        "#": "#",
        "Invoice Reference Number": "מספר חשבונית",
        "Vehicle Registration Numbers": "מספר רישום רכב"
      },
      buttonKey: {
        Rentals: "השכרות",
        Subscriptions: "מנויים",
        "Test Drive": "נסיעת מבחן",
        "Contract Hire": "חכירה לפי חוזה",
      },
      subLabelKey: {
        "Book vehicle for hours and days": "הזמן רכב לפי שעות וימים",
        "Subscribe vehicle for weekly/monthly": "הירשם לרכב שבועי/חודשי",
        "Test Drive our Premium Vehicles":
          "בצע נסיעת מבחן ברכבים המובחרים שלנו",
        "Contract Hire vehicle for weekly/monthly":
          "חכירת רכב שבועית/חודשית לפי חוזה",
      },
      buttonTextKey: {
        "Subscribe Now": "הירשם עכשיו",
        "Book Now": "הזמן עכשיו",
        "Contract Now": "חתום על חוזה עכשיו",
      },
      featuresKey: {
        "Flexible Leasing Options": "אפשרויות ליסינג גמישות",
        "Choose the duration of your subscription as you go":
          "בחר את משך המנוי שלך תוך כדי תנועה",
        "Change car anytime*": "החלף רכב בכל עת*",
        "Home delivery option": "אפשרות משלוח עד הבית",
        "100% digital": "100% דיגיטלי",
        "MOT and taxes": "טסט ומיסים",
        "Without down payment": "ללא מקדמה",
        "Vehicle Servicing": "טיפול ברכב",
      },
      adjustmentColumnKey: {
        "#": "#",
        Amount: "סכום",
        "Adjusted To Invoice": "עודכן לחשבונית",
        "Adjusted At": "עודכן ב",
      },
      categoriesKey: {
        Knowledge: "ידע",
        Behavior: "התנהגות",
        Punctuality: "עמידה בזמנים",
      },
    },
    snackBar: {
      customerInfoSaved: "מידע על לקוחות נשמר",
      documentDeleted: "המסמך נמחק בהצלחה",
      documentDeleteFailed: "מחיקת מסמך נכשלה",
      documentDeleteError: "שגיאה במחיקת מסמך",
      documentMarkedForDeletion:
        "המסמך מסומן למחיקה. השינויים יחולו כאשר תשמור. ",
      profileImageUploaded: "תמונת הפרופיל הועלה בהצלחה",
      uploadImageFormatError: "אנא העלה רק. JPEG/.JPG/.PNG פורמט תמונה!",
      selectDocumentType: "אנא בחר סוג מסמך",
      selectExpiryDate: "אנא בחר תאריך תפוגה של מסמך",
      fileSizeExceeded50mb: "גודל הקובץ חרג מגבלה של 50MB",
      fileSizeExceeded5mb: "גודל הקובץ חרג מגבלה של 5MB",
      uploadSuccess: "המסמך הועלה בהצלחה",
      invalidUploadFormat: "אנא העלה רק קבצי PDF, PNG, JPG או JPEG",
      selectExpiryDateUpload: "אנא בחר תאריך תפוגה לפני העלאה",
      ImageUploaded: "התמונה הועלה בהצלחה",
      invalidFileType: "סוג קובץ לא חוקי. סוגים מותרים: jpeg או png",
      costCenterInfoMissing: "מידע מרכז עלות חסר!",
      selectedDriverAlreadyAdded: "נהג שנבחר כבר נוסף.",
      driverSavedSuccessfully: "הנהג נשמר בהצלחה.",
      additionalDriverCannotBeMore:
        "נהגים נוספים לא יכולים להיות יותר מהכמות של התוספים",
      verificationStatusInReview: "מצב האימות נמצא בבדיקה",
      verificationStatusPending: "מצב האימות ממתין",
      quoteCreated: "הצעת מחיר נוצרה",
      bookingCreated: "ההזמנה נוצרה",
      pickUpLocationEmpty: "מיקום האיסוף ריק",
      slotSelectionRequiredForNonNegotiable: "נדרש בחירת משבצת.",
      protectionPlanMandatoryForPCOBooking: "תוכנית הגנה חובה להזמנת PCO",
      paymentAlreadyDone: "התשלום כבר בוצע",
      fileBeingGenerated: "הקובץ נוצר, אנא נסה שוב מאוחר יותר",
      provideDeliveryAddress: "אנא הזן כתובת למשלוח!",
      noValidCreditReadingFound: "לא נמצאה קריאת אשראי תקפה לחברה זו.",
      noValidCreditScoreFound:
        "לא נמצא ציון אשראי תקף. ייתכן שהגעת למכסת הבדיקות",
      atleastOneLicenceImage: "יש להעלות לפחות תמונת רישיון אחת",
      licenceImageUploaded: "תמונת רישיון הועלתה בהצלחה",
      maximumTwoImageLicence: "ניתן להעלות עד שתי תמונות לרישיון בלבד!",
      imageUploadInProgress: "אנא המתן, התמונה בתהליך העלאה!",
      errorFetchingSignedUrl: "שגיאה באחזור קישור חתום",
      paymentFailed: "התשלום נכשל, נסה שוב",
      paymentFailedReasonCardDetails:
        "התשלום נכשל! בדוק את פרטי הכרטיס או נסה מאוחר יותר.",
      maximumTwoImage: "ניתן להעלות עד שתי תמונות עבור",

      cancelledSuccessfully: "בוטל בהצלחה",
      selectReasonForCancel: "אנא הזן את הסיבה לביטול",
      streetZipcodeRequired: "נדרש רחוב / מיקוד",
      feedbackSaved: "תודה! המשוב שלך נשמר",
      driverAlreadyAdded: "הנהג כבר נוסף!",
      driverRemoved: "הנהג הוסר בהצלחה",
      businessCustomerDriverDeleted: "נהג לקוח עסקי נמחק.",
      errorInSavingData: "שגיאה בשמירת הנתונים",
      damageInformationSaved: "מידע על נזקים נשמר בהצלחה.",
      errorSavingData: "שגיאה בשמירת נתונים",
      problemTelematicsData: "בעיה בטעינת נתוני טלמטיקה",
      verificationRequestSent: "בקשת אימות נשלחה בהצלחה.",
      vehicleStateUpdated: "מצב הרכב עודכן",
      driverAdded: "נהג נוסף.",
      businessCustomerCreated: "לקוח עסקי נוצר.",
      uploadOnlyImageFiles: "אנא העלה קבצי תמונה בלבד (PNG, JPEG, JPG)",
      imageSizeExceed5MB: "גודל התמונה לא צריך לעלות על 5MB",
      uploadFailed: "ההעלאה נכשלה",
      imagesUploadedSuccessfully: "תמונה/ות הועלו בהצלחה!",
      failedToUploadImages: "העלאת התמונות נכשלה. אנא נסה שוב.",
      pleaseSelectVehicle: "אנא בחר רכב",
      pleaseFillInAllIssueDetails: "אנא מלא את כל פרטי הבעיה",
      serviceRequestCreatedSuccessfully: "בקשת השירות נוצרה בהצלחה! אסמכתא:",
      errorCreatingServiceRequest: "שגיאה ביצירת בקשת השירות",
      pleaseEnterNote: "אנא הזן הערה",
      noteAddedSuccessfully: "הערה נוספה בהצלחה",
      errorAddingNote: "שגיאה בהוספת הערה",
      pleaseAnswerAllRemainingQuestions: "אנא ענה על כל {{count}} השאלות{{plural}} הנותרות",
      answersSubmittedSuccessfully: "התשובות הוגשו בהצלחה! הבקשה שלך נמצאת כעת בבדיקה.",
      errorSubmittingAnswers: "שגיאה בהגשת תשובות",
      serviceRequestNotFound: "בקשת שירות לא נמצאה",
      errorLoadingServiceRequests: "שגיאה בטעינת בקשות שירות",
      oneVehicleForContactless: "ניתן לבחור רכב אחד בלבד להזמנה ללא מגע",
      oneVehicleForNonContactless: "ניתן לבחור רק רכב ללא מגע או רכב Smartcar להזמנה ללא מגע",
      contactlessVehicleCannotBeSelected: "לא ניתן לבחור רכב ללא מגע להזמנות רגילות",
      bookingDetailsCreated: "פרטי ההזמנה נוצרו"
    },
  },
};